import { Either } from './either';
export function either(left, right) {
    return new Either(left, right);
}
//# sourceMappingURL=either.factory.js.map